export class SETTINGS {
  public static BASE_API = "localhost:3000";

  public static KEYS = {
    SECRET: "iIUsWtNZcf",
  };

  public static ACCESS_TOKEN = "%&^%^*@&*#";
  public static REFRESH_TOKEN = "&@&#&$(@&##";
  public static USER_PRIVILEGES = "%$^%((*";
  public static USER_PERMISSIONS = ")(&^&%^$*&*&$&*()*";
  public static USER_ROLE = ")(&^&%^$*&**&^%^&&^&&$&*()*";
  public static LOGGED_IN_USER = "#$%@^^%";

}
